import { apiClient } from "../../base/ApiClient";


export const getLogs = async ({
  page = 1,
  pageSize = 10,
  noPagination = false,
  params = {},
} = {}) => {
  const query = { ...params };

  query.pagination = noPagination ? "false" : "true";

  if (!noPagination) {
    query.page = page;
    query.page_size = pageSize;
  }

  const res = await apiClient.get("/logs/changelogs/", { params: query });
  return res.data;
};